// @ts-nocheck
/* eslint-disable */
export const priorityHighIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99996 14C8.73634 14 9.33329 13.403 9.33329 12.6667C9.33329 11.9303 8.73634 11.3333 7.99996 11.3333C7.26358 11.3333 6.66663 11.9303 6.66663 12.6667C6.66663 13.403 7.26358 14 7.99996 14Z" fill="currentColor"/><path d="M6.66663 2H9.33329V10H6.66663V2Z" fill="currentColor"/></svg>`,
    name: 'priority-high' as const
};